/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Title_Line2Inputs */

const en_home_title_line2 = /** @type {(inputs: Home_Title_Line2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`in your browser.`)
};

const fr_home_title_line2 = /** @type {(inputs: Home_Title_Line2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`dans votre navigateur.`)
};

const ms_sg2_home_title_line2 = /** @type {(inputs: Home_Title_Line2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`dalam pelayar anda.`)
};

/**
* | output |
* | --- |
* | "in your browser." |
*
* @param {Home_Title_Line2Inputs} inputs
* @param {{ locale?: "en" | "fr" | "ms-SG" }} options
* @returns {LocalizedString}
*/
export const home_title_line2 = /** @type {((inputs?: Home_Title_Line2Inputs, options?: { locale?: "en" | "fr" | "ms-SG" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Title_Line2Inputs, { locale?: "en" | "fr" | "ms-SG" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_home_title_line2(inputs)
	if (locale === "fr") return fr_home_title_line2(inputs)
	return ms_sg2_home_title_line2(inputs)
});